
const MoltinGateway = require('@moltin/sdk').gateway;

// let client_id = 'PzLawqa3njH8sJwfjCv7poCl7vaOunzlGGqayxLTyI';
// let client_secret = 'BZrB6NIDFFDbMtxKwvweci2kkyXmO5cD0anNB3bTmm' ;
// let grant_type = "client_credentials";

// if (process.env.REACT_APP_MOLTIN_CLIENT_ID) {
//   client_id = process.env.REACT_APP_MOLTIN_CLIENT_ID;
// }

const Moltin = MoltinGateway({
  client_id : 'PzLawqa3njH8sJwfjCv7poCl7vaOunzlGGqayxLTyI',
  client_secret : 'BZrB6NIDFFDbMtxKwvweci2kkyXmO5cD0anNB3bTmm' 
});




export const GetProducts = () =>
  Moltin.Products.With('files, main_images, collections').All();

// export const GetProductVariations = () =>

export const GetProduct = ID => Moltin.Products.Get(ID);

export const GetCategories = () => Moltin.Categories.With('products').All();

export const GetCategory = ID => Moltin.Categories.Get(ID);

export const GetCollections = () => Moltin.Collections.With('products').All();

export const GetBrands = () => Moltin.Brands.All();

export const GetFile = ID => Moltin.Files.Get(ID);

export const AddCart = (id, quantity) => Moltin.Cart.AddProduct(id, quantity);

export const AddShipping = () => Moltin.Cart.AddCustomItem(shipping);

export const browPomade = (color ) => Moltin.Cart.AddCustomItem(color);

export const UpdateCartPlus = (ID, quantity) =>
  Moltin.Cart.UpdateItemQuantity(ID, quantity + 1);

export const UpdateCartMinus = (ID, quantity) =>
  Moltin.Cart.UpdateItemQuantity(ID, quantity - 1);

export const UpdateCart = (ID, quantity) =>
  Moltin.Cart.UpdateItemQuantity(ID, quantity);

export const GetCartItems = () => Moltin.Cart.Items();

export const Checkout = data => AddShipping(Moltin.Cart.Checkout(data));

export const GetOrder = ID => Moltin.Orders.Get(ID);

export const OrderPay = (ID, data) => Moltin.Orders.Payment(ID, data);

export const DeleteCart = () => Moltin.Cart.Delete();

 //Add Custom Shipping item
 const shipping = {
  type: "custom_item",
  name: 'Flat Rate Shipping',
  sku: 'flat-rate-shipping',
  description: 'stock up and stay pretty with affordable, fast flat rate shipping',
  quantity: 1,
  price: {
    amount: 670
  }
}


  

// export const Authenticate = () => Moltin.Authenticate().then(response => {
//   console.log('authenticated', response);
//   return (response);
// });



// WEBPACK FOOTER //
// ./src/moltin.js


// WEBPACK FOOTER //
// ./src/moltin.js